import React from "react";
import Navbar from "../Components/Navbar";
import Main from "../Components/Main";
import Info from "../Components/Info";
import About from "../Components/About";
import Privacy from "../Components/Privacy";
import Contact from "../Components/Contact";
import Footer from "../Components/Footer";

function Home() {
  return (
    <div className="home-section">
      <Navbar />
      <Main />
      <Info />
      <About />
      <Privacy />
      <Contact />
      <Footer />
    </div>
  );
}

export default Home;
